export default __webpack_public_path__ + "static/media/loading-secondary.212bd8cc.png";